import cn from 'classnames';
import { FormContext } from 'informed';
import { useTranslation } from 'react-i18next';

import { InformedCheckbox } from '@nw/design-system/omega';

import {
  defaultRefundPolicyLabel,
  defaultTermsAndConditionsLabel
} from '../../constants/TermsAndConditionsConstants';
import { ApplicationProductFieldValidationSchema } from '../../utils/userRoleDetailsAndApplicationProductValidationSchema';

import { FieldContainer } from '../ApplicationSectionsPage/styledComponents';

interface TermsAndConditionsProps {
  termsAndConditionsLabel?: string;
  refundPolicyLabel?: string;
  campusChangeAcknowledgementLabel?: string;
  showCampusChangeAcknowledgement?: boolean;
}

export const TermsAndConditions = (
  formProps: FormContext,
  termsAndConditionsProps?: TermsAndConditionsProps
): React.ReactNode => {
  const { t } = useTranslation();
  const {
    termsAndConditionsLabel = defaultTermsAndConditionsLabel,
    refundPolicyLabel = defaultRefundPolicyLabel,
    campusChangeAcknowledgementLabel = '',
    showCampusChangeAcknowledgement = false
  } = termsAndConditionsProps ?? {};

  const renderCheckBoxField = (
    formProps: FormContext,
    field,
    label,
    shouldShowOnlyLabel = false
  ) => {
    const { formState } = formProps;
    const { touched, errors, values } = formState;
    return (
      <FieldContainer>
        <InformedCheckbox
          field={field}
          key={field}
          label={label}
          error={errors[field]}
          touched={touched[field]}
          shouldShowOnlyLabel={shouldShowOnlyLabel}
          validationSchemaObject={ApplicationProductFieldValidationSchema(t)}
          isInnerHTML={true}
          validateOnBlur={false}
          labelClassName={cn('informedInputLabelCheckboxText')}
          isMarginBottomZero={true}
        />
      </FieldContainer>
    );
  };
  return (
    <>
      {renderCheckBoxField(
        formProps,
        'communicationConsent',
        'I consent to receiving communications from NxtWave.'
      )}
      {showCampusChangeAcknowledgement
        ? renderCheckBoxField(
            formProps,
            'nxtwaveCampusChangePolicy',
            campusChangeAcknowledgementLabel
          )
        : null}
      {renderCheckBoxField(
        formProps,
        'nxtwaveTermsAndConditions',
        termsAndConditionsLabel
      )}
      {renderCheckBoxField(
        formProps,
        'nxtwaveRefundPolicy',
        refundPolicyLabel,
        true
      )}
    </>
  );
};
